// extracted by mini-css-extract-plugin
module.exports = {"signUp":"ui_signUp__1E5x9"};